import React from "react";
import { Skeleton } from "@picklebet/ui";
import * as styles from "./AmountInputSkeleton.module.scss";

/** matches the increments plus Max that `AmountPresets` renders */
const DEFAULT_PRESET_COUNT = 5;

type AmountInputSkeletonProps = {
  presetCount?: number;
};

export const AmountInputSkeleton = ({
  presetCount = DEFAULT_PRESET_COUNT,
}: AmountInputSkeletonProps) => {
  return (
    <div className={styles.container}>
      <Skeleton span="quart" className={styles.input} />

      <div className={styles.presets}>
        {Array.from({ length: presetCount }, (_, index) => (
          <Skeleton key={index} className={styles.preset} />
        ))}
      </div>
    </div>
  );
};
